import 'antd/dist/antd.css';
import './App.css';
import LandingPage from './components/LandingPage';
import firebase from "firebase";

const config = {
  apiKey: "AIzaSyDl1Rc1XGq7_hfefcfx1o99pkakPD4JSec",
  authDomain: "e-dairy-5698.firebaseapp.com",
  databaseURL: "https://e-dairy-5698-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "e-dairy-5698",
  storageBucket: "gs://e-dairy-5698.appspot.com",
  messagingSenderId: "762686119983",
  appId: "1:762686119983:web:2e9e2ab04eac4552ace6da"
};

firebase.initializeApp(config);

function App() {
  return (
    <div className="App">
      <LandingPage/>
    </div>
  );
}

export default App;
